import { Component, OnInit } from '@angular/core';
import { AuditdetailsserviceService } from '../creation/auditor-details/auditdetailsservice.service';
import { AuditFrequencyModel, projectNamesModel } from '../creation/auditor-details/DataModels';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { CategoryModel } from '../project-overview/models/category.model';

@Component({
  selector: 'app-project-settings',
  templateUrl: './project-settings.component.html',
  styleUrls: ['./project-settings.component.css']
})
export class ProjectSettingsComponent implements OnInit {

  projectList:Array<projectNamesModel> = [];
  auditFrequencyList:Array<AuditFrequencyModel> = [];
  auditCategoryList:Array<CategoryModel> = [];
  selectedProjectId:number = -1;
  selectedFrequencyId:number = -1;

  constructor(private auditorDetailService:AuditdetailsserviceService
             ,private auditOverviewService: AuditOverviewService) {
    this.projectList = new Array<projectNamesModel>();
    this.auditFrequencyList = new Array<AuditFrequencyModel>();
    this.auditCategoryList = new Array<CategoryModel>();
  }
  
  ngOnInit(): void {
    this.getProjects();
    this.getAuditFrequencyOptions();
    this.getCategoryDropDown();
  }


  getProjects() {
    this.auditorDetailService.getProjectName().subscribe(
      (response: projectNamesModel[]) => {
        if(response?.length > 0){
          this.projectList = response;  
        }
      },
      (error:any) => {
        console.log(`getProjects(): Error - ${error}`);
      });
  }

  getAuditFrequencyOptions(){
    this.auditorDetailService.getAuditFrequencyOptions().subscribe(
      (response: AuditFrequencyModel[]) => {
        if(response?.length > 0){
          this.auditFrequencyList = response;  
        }
      },
      (error:any) => {
        console.log(`getAuditFrequencyOptions(): Error - ${error}`);
      });
  }

  getCategoryDropDown() {
    this.auditOverviewService.getCategoryDropDown().subscribe(
      (response :  Array<CategoryModel>) => {
        if (response?.length > 0) {
          this.auditCategoryList = response;  
        }
      },
      (error) => { 
        console.log(`getCategoryDropDown(): Error`, error); 
      }
    )
  }



}